import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { Input } from '@/components/Input.tsx'
import { FormElement } from '@/components/templates/Form.tsx'

const useFieldError = (errors: z.ZodIssue[]) => {
  return (fieldName: string) => errors?.find((e) => e.path[0] === fieldName)
}

export const FormField = ({
  allErrors,
  defaultValue,
  fieldName,
  fieldType,
  trackFormInteraction,
}: {
  fieldName: string
  fieldType: string
  defaultValue?: string | number
  trackFormInteraction: (data: {
    action: 'click'
    formFieldName: string
  }) => void
  allErrors?: z.ZodIssue[]
}) => {
  const { t: tGeneral } = useTranslation('translation')
  const fieldError = useFieldError(allErrors || [])

  return (
    <FormElement>
      <Input
        label={tGeneral(`fields.${fieldName}.label`)}
        type={fieldType}
        name={fieldName}
        defaultValue={defaultValue}
        onFocus={() => {
          trackFormInteraction({
            action: 'click',
            formFieldName: fieldName,
          })
        }}
        errorMessage={
          fieldError(fieldName)
            ? tGeneral(`fields.${fieldName}.error`)
            : undefined
        }
      />
    </FormElement>
  )
}
